import { withState } from 'recompose';

export default withState('batchWarning', 'updateBatchWarning', null);
